import { Link, useParams, useNavigate } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import DeleteModal from '../../../components/deleteModal/DeleteModal';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const CashDeskManage = () => {
  const { branchId } = useParams();
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [units, setUnits] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    unitId: 0,
    title: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    description: "",
    unitId: 0,
    branchId: branchId
  });
  const getGridData = async () => {
    const resp = await apiMethod.getCashDesks(filterModel.branchId, filterModel.size, filterModel.part, filterModel.title, filterModel.unitId);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getAllUnits(filterModel.branchId);
    if (methods.showApiErrors(resp1))
      setUnits(resp1.data);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push('.عنوان باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.unitId)) {
      errors.push('.بخش  باید مقدار داشته باشد');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.description = "";
    formModel.unitId = "";
    formModel.branchId = branchId;
    setFormModel({ ...formModel });
    setShowFormModal(false);
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.unitId = 0;
    filterModel.title = '';
    filterModel.size = 20;
    filterModel.part = 1;
    setFilterModel({ ...filterModel })
  };

  const editItem = async (id) => {

    setLoading(true);
    const resp = await apiMethod.getCashDeskInfo(id);
    if (!methods.showApiErrors(resp))
      return false;

    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.description = resp.data.description;
    formModel.unitId = resp.data.unitId;
    formModel.branchId = resp.data.branchId;
    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const createNewItem = async (e) => {
    if (!validForm())
      return false;

    setLoading(true);

    try {
      const resp = await apiMethod.createCashdesk(formModel);

      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowFormModal(false);
    }
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-block'>
              <Link to={`/sale/${branchId}/#3`} className='text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/#3`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                صندوق
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p> صندوق
                <a href={`/sale/${branchId}/softwareGuide/#section8`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row g-1'>
                  <div className='col-12 col-md-4 col-lg-3'>
                    <label htmlFor="funit" className="form-label">بخش فروش</label>
                    <select
                      id="funit"
                      className="form-select form-select-md"
                      value={filterModel.unitId}
                      onChange={(e) => {
                        filterModel.unitId = e.target.value;
                        setFormModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه‌ی بخش‌ها </option>
                      {units.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className='col-12 col-md-4 col-lg-4'>
                    <label htmlFor="funit" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={filterModel.title}
                        onChange={(e) => { setFilterModel({ ...filterModel, title: e.target.value, part: 1 }) }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='col-12 col-md-4 col-lg-5'>
                    <div className='createButton'>
                      <button
                        onClick={() => { openNewForm() }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>صندوق جدید</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                {units.length === 0 ? (
                  <div className='my-5'>
                    <div>
                      <span>اطلاعات مربوط به این بخش باید تکمیل شود. </span>
                      <button className='btn btn-outline-purple' onClick={() => { navigate(`/sale/:branchId/saleunits`) }}>افزودن بخش فروش</button>
                    </div>
                  </div>
                ) :
                  <>
                    <table className="table table-striped table-md align-middle" >
                      <thead className=''>
                        <tr>
                          <th scope="col vertical-center" width="20px">ردیف</th>
                          <th scope="col vertical-center">عنوان</th>
                          <th scope="col vertical-center">بخش فروش</th>
                          <th scope="col vertical-center">توضیحات</th>
                          <th scope="col vertical-center">وضعیت</th>
                          <th scope="col vertical-center">کاربر صندوق</th>
                          <th scope="col vertical-center">پوز</th>
                          <th scope="col vertical-center">سوابق صندوق</th>
                          <th scope="col vertical-center">پرینتر صندوق</th>
                          <th scope="col vertical-center" width="100px">عملیات</th>
                        </tr>
                      </thead>
                      <tbody className=''>
                        {gridData.map((cashDesk, index) => (
                          <tr key={cashDesk.id}>
                            <th scope="row">{((filterModel.part - 1) * filterModel.size) + index + 1}</th>
                            <td>{cashDesk.title}</td>
                            <td>{cashDesk.salesUnitTitle}</td>
                            <td>{cashDesk.description}</td>
                            <td>
                              <div className='d-flex align-items-middle'>
                                <span className={`status-span mt-1 ${cashDesk.isActive ? 'activespan' : 'inactivespan'}`}></span>
                                <span className={`me-1 ${!cashDesk.isActive ? 'inactive-text' : 'active-text'}`}>
                                  {cashDesk.isActive ? 'فعال' : 'غیرفعال'}
                                </span>
                              </div>
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-purple"
                                onClick={() => navigate(`/sale/${branchId}/cashier/cashierManager/${cashDesk.id}`)}
                              >
                                کاربر صندوق
                                <span className="badge tablebadge">{cashDesk.userCount}</span>
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-purple"
                                onClick={() => navigate(`/sale/${branchId}/cashier/deskPos/${cashDesk.id}`)}
                              >
                                پوزها
                                <span className="badge tablebadge">{cashDesk.posCount}</span>
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-purple"
                                onClick={() => navigate(`/sale/${branchId}/cashier/deskRecord/${cashDesk.id}`)}
                              >
                                بستن صندوق
                                <span className="badge tablebadge">{cashDesk.offCount}</span>
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-purple"
                                onClick={() => navigate(`/sale/${branchId}/cashier/deskPrinter/${cashDesk.id}`)}
                              >
                                پرینتر صندوق
                                <span className="badge tablebadge">{cashDesk.printerCount}</span>
                              </button>
                            </td>
                            <td>
                              <button
                                onClick={() => editItem(cashDesk.id)}
                                className='btn btn-sm btn-outline-purple me-2' type='button'>
                                <i className="bi bi-pencil-square"></i>
                              </button>
                              <button
                                onClick={() => selectَItemToDelete(cashDesk)}
                                className='btn btn-sm btn-outline-danger' type='button'>
                                <i className="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {filterModel.parts > 1 &&
                      <nav aria-label="Page navigation example" className='mt-5'>
                        <ul className="pagination justify-content-center">
                          <li className="page-item mx-1">
                            <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                              <i className="bi bi-chevron-compact-right"></i>
                            </a>
                          </li>
                          {makePagerItems()}
                          <li className="page-item mx-1">
                            <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                              <i className="bi bi-chevron-compact-left"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    }
                  </>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const openNewForm = async () => {
    resetForm();
    setShowFormModal(true);
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
  };

  const closeDelelteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَItemToDelete = (item) => {
    setFormModel(item);
    setShowDeleteModal(true);
  };

  const deleteCashDeskItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeCashDesk(formModel.id);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;

  };

  const ModalCreateCashDesk = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showFormModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-md" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title"> ایجاد / ویرایش صندوق</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label htmlFor="title" className="form-label required-label">عنوان</label>
                  <input type="text" className="form-control" id="title" name="title"
                    value={formModel.title}
                    onChange={(e) => { setFormModel({ ...formModel, title: e.target.value }) }}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="unitTitle" className="form-label required-label">بخش</label>
                  <select
                    id="saleUnit"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.unitId}
                    onChange={(e) => {
                      formModel.unitId = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value={0}>همه‌ی بخش‌ها </option>
                    {units.map((saleUnit) => (
                      <option key={saleUnit.id} value={saleUnit.id}>
                        {saleUnit.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12">
                  <label htmlFor="description" className="form-label">توضیحات</label>
                  <textarea type="text" className="form-control" id="description" name="description" rows={3}
                    value={formModel.description}
                    onChange={(e) => { setFormModel({ ...formModel, description: e.target.value }) }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
              <button type="submit" className="btn custome-btn btn-purple w-50"
                onClick={() => { createNewItem() }}
              >ثبت وذخیره</button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderItems()}
      {showFormModal && ModalCreateCashDesk()}
      {showDeleteModal &&
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDelelteModal}
          deleteItem={deleteCashDeskItem}
          text={'صندوق'}
        />
      }
    </>
  );
}

export default CashDeskManage;